/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiUserTasksGetLastSelectedIdParameter,
  ApiUserTasksGetPageParameter,
  CreateClassRoomRequest,
  GetClassRoomResponse,
  PaginatedResultOfGetClassRoomResponse,
  Result,
  ResultOfCreateClassRoomResponse,
  SearchQueryRequest,
  UpdateClassRoomRequest,
} from '../models/index';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterToJSON,
    CreateClassRoomRequestFromJSON,
    CreateClassRoomRequestToJSON,
    GetClassRoomResponseFromJSON,
    GetClassRoomResponseToJSON,
    PaginatedResultOfGetClassRoomResponseFromJSON,
    PaginatedResultOfGetClassRoomResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCreateClassRoomResponseFromJSON,
    ResultOfCreateClassRoomResponseToJSON,
    SearchQueryRequestFromJSON,
    SearchQueryRequestToJSON,
    UpdateClassRoomRequestFromJSON,
    UpdateClassRoomRequestToJSON,
} from '../models/index';

export interface ApiClassRoomsIdDeleteRequest {
    id: number;
    xTenantID?: number;
}

export interface ApiClassRoomsPostRequest {
    createClassRoomRequest: CreateClassRoomRequest;
    xTenantID?: number;
}

export interface ApiClassRoomsPutRequest {
    updateClassRoomRequest: UpdateClassRoomRequest;
    xTenantID?: number;
}

export interface ApiClassRoomsScrollGetRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
}

export interface ApiClassRoomsSearchPostRequest {
    page?: ApiUserTasksGetPageParameter;
    pageSize?: ApiUserTasksGetPageParameter;
    lastSelectedId?: ApiUserTasksGetLastSelectedIdParameter;
    active?: boolean;
    xTenantID?: number;
    searchQueryRequest?: SearchQueryRequest;
}

export interface GetClassRoomByIdRequest {
    id: number;
    xTenantID?: number;
}

/**
 * 
 */
export class ClassRoomsApi extends runtime.BaseAPI {

    /**
     * Deletes a class room by its ID
     * Delete class room
     */
    async apiClassRoomsIdDeleteRaw(requestParameters: ApiClassRoomsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiClassRoomsIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-rooms/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a class room by its ID
     * Delete class room
     */
    async apiClassRoomsIdDelete(requestParameters: ApiClassRoomsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassRoomsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Create class-room
     */
    async apiClassRoomsPostRaw(requestParameters: ApiClassRoomsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreateClassRoomResponse>> {
        if (requestParameters['createClassRoomRequest'] == null) {
            throw new runtime.RequiredError(
                'createClassRoomRequest',
                'Required parameter "createClassRoomRequest" was null or undefined when calling apiClassRoomsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-rooms`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClassRoomRequestToJSON(requestParameters['createClassRoomRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreateClassRoomResponseFromJSON(jsonValue));
    }

    /**
     * Create class-room
     */
    async apiClassRoomsPost(requestParameters: ApiClassRoomsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreateClassRoomResponse> {
        const response = await this.apiClassRoomsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update class-room
     */
    async apiClassRoomsPutRaw(requestParameters: ApiClassRoomsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateClassRoomRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClassRoomRequest',
                'Required parameter "updateClassRoomRequest" was null or undefined when calling apiClassRoomsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-rooms`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClassRoomRequestToJSON(requestParameters['updateClassRoomRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update class-room
     */
    async apiClassRoomsPut(requestParameters: ApiClassRoomsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiClassRoomsPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get all class-rooms
     */
    async apiClassRoomsScrollGetRaw(requestParameters: ApiClassRoomsScrollGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetClassRoomResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-rooms/scroll`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetClassRoomResponseFromJSON(jsonValue));
    }

    /**
     * Get all class-rooms
     */
    async apiClassRoomsScrollGet(requestParameters: ApiClassRoomsScrollGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetClassRoomResponse> {
        const response = await this.apiClassRoomsScrollGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search class-rooms
     */
    async apiClassRoomsSearchPostRaw(requestParameters: ApiClassRoomsSearchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedResultOfGetClassRoomResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['lastSelectedId'] != null) {
            queryParameters['lastSelectedId'] = requestParameters['lastSelectedId'];
        }

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-rooms/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchQueryRequestToJSON(requestParameters['searchQueryRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedResultOfGetClassRoomResponseFromJSON(jsonValue));
    }

    /**
     * Search class-rooms
     */
    async apiClassRoomsSearchPost(requestParameters: ApiClassRoomsSearchPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedResultOfGetClassRoomResponse> {
        const response = await this.apiClassRoomsSearchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get class-room
     */
    async getClassRoomByIdRaw(requestParameters: GetClassRoomByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetClassRoomResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getClassRoomById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/class-rooms/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetClassRoomResponseFromJSON(jsonValue));
    }

    /**
     * Get class-room
     */
    async getClassRoomById(requestParameters: GetClassRoomByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetClassRoomResponse> {
        const response = await this.getClassRoomByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
